// $(function(){
//     $('.lazy-load').Lazy({
//         effect: 'fadeIn',
//         effectTime: 300
//     });
// });

$(function () {

    var rellax = new Rellax('.top-banner', {
        speed: -6,
    });

    var rellax = new Rellax('.splash-page__video', {
        speed: -6,
    });

    // var rellax = new Rellax('.panel__background--parallax', {
    //     speed: -0.6,
    // });


    // var rellax = new Rellax('.row', {
    //     speed: -1,
    // });


    // Add class if edge
    if (/Edge/.test(navigator.userAgent)) {
        $('body').addClass('ie ie--edge');
    }

    // Add class if IE 11
    var is_ie11 = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
    if (is_ie11) {
        $('body').addClass('ie ie--11');
    }

    // Add class if IE10
    var is_ie10 = navigator.appVersion.indexOf("MSIE 10") !== -1;
    if (is_ie10) {
        $('body').addClass('ie ie--10');
    }

    // Add class if safari
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (is_safari) {
        $('body').addClass('body--safari');
    }

    /* === Add aria labels to owl carousel buttons === */
    $('.owl-carousel').each(function() {
        //Find each set of dots in this carousel
        $(this).find('.owl-dot').each(function(index) {
            //Add one to index so it starts from 1
            $(this).attr('aria-label', index + 1);
        });
    });

});


/* NAVIGATION */

//   $(function() {
//     var pull = $('#pull');
//     menu = $('nav');

//     $(pull).on('click', function(e) {
//       e.preventDefault();
//       menu.toggleClass("hide");
//       $(this).toggleClass("active");
//       $('.menu-button').toggleClass("closed");
//       $('section.body').toggleClass("no-nav");
//       $('nav li.active').toggleClass("active");
//     });

//     /*
//     $(document).ready(function() {
//       var viewportWidth = $(window).width();
//       if (viewportWidth < 992) {
//           menu.addClass("hide");
//           $('section.body').addClass("no-nav");
//           $('.menu-button').addClass("closed");
//       }
//     });
//     */


//   });



  /* cookie notice */

$(function () {
    if (!!Cookies.get('IDCookie')) {
        // console.log("there is a cookie");
    } else {
        $('.cookie-notice').css('display', 'block');
        $('.cookie-notice__close').click(function () {
            Cookies.set('IDCookie', 'accepted', {
                expires: 365
            });
            $(this).parent().parent().hide();
        })
    }
})


  /* SEARCH */

//   $(function() {

//     $('.search-icon').on('click', function(e) {
//       e.preventDefault();
//       $(this).toggleClass("active");
//       $('.search-form').toggleClass("active");
//     });

//   });



/* NEWS GALLERY */

// $(function() {
//   $(".news-links li").click(function() {
//     $('.news-links li.active').removeClass('active');
//     $(this).addClass('active');

//     var id = $(this).attr("id");
//     $(".news-img div").css("display", "none");
//     $(".news-img div#" + id + "").css("display", "block");
//   });
//   $(".news-img div:not(#1)").css("display", "none");
// });


/* ACCORDION */

// $(function() {
//   $('.accordion .toggle').click(function() {
//     $(this).parent().toggleClass('active');
//   });
// })


/* Trade zone range selector*/
$(function () {
    $('#rangeSelect').change(function () {
        //alert($(this).val());
        $('.range').removeClass("showRange");
        $('.range-' + $(this).val()).addClass("showRange");
    });
})


/* SCROLL PLUGIN */

/*Interactivity to determine when an animated element in in view. In view elements trigger our animation*/
// $(document).ready(function() {

//   //window and animation items
//   var animation_elements = $.find('.animation-element');
//   var web_window = $(window);

//   //check to see if any animation containers are currently in view
//   function check_if_in_view() {
//     //get current window information
//     var window_height = web_window.height();
//     var window_top_position = web_window.scrollTop();
//     var window_bottom_position = (window_top_position + window_height);

//     //iterate through elements to see if its in view
//     $.each(animation_elements, function() {

//       //get the element sinformation
//       var element = $(this);
//       var element_height = $(element).outerHeight();
//       var element_top_position = $(element).offset().top;
//       var element_bottom_position = (element_top_position + element_height);

//       //check to see if this current container is visible (its viewable if it exists between the viewable space of the viewport)
//       if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
//         element.addClass('in-view');
//       } else {
//         element.removeClass('in-view');
//       }
//     });

//   }

//   //on or scroll, detect elements in view
//   $(window).on('scroll resize', function() {
//       check_if_in_view()
//     })
//     //trigger our scroll event on initial load
//   $(window).trigger('scroll');

// });
